import { render, staticRenderFns } from "./ToolsComen.vue?vue&type=template&id=35f27f96&scoped=true"
import script from "./ToolsComen.vue?vue&type=script&lang=js"
export * from "./ToolsComen.vue?vue&type=script&lang=js"
import style0 from "./ToolsComen.vue?vue&type=style&index=0&id=35f27f96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f27f96",
  null
  
)

export default component.exports